<template>
  <div
    class="bbp-project-popup-info"
    :class="[isDynamic && 'bbp-project-popup-info_dynamic']"
  >
    <div class="container bbp-project-popup-info__container">
      <div v-if="text"
           class="bbp-project-popup-info__header"
           :class="{'bbp-project-popup-info__header_border': !description}"
      >
        <div class="bbp-project-popup-info__title">{{subTitle}}</div>
        <p class="bbp-project-popup-info__subtitle">{{text}}</p>
      </div>
      <div class="bbp-project-popup-info__content"
           v-if="description"
           :class="{'bbp-project-popup-info__content_padding': !text}"
      >
        <div class="bbp-project-popup-info__title">{{title}}</div>
        <p class="bbp-project-popup-info__subtitle">{{description}}</p>
      </div>
      <div class="bbp-project-popup-info__header"
           :class="{'bbp-project-popup-info__header_border': !description}"
           v-if="descriptionReject"
      >
        <div class="bbp-project-popup-info__title">{{title}}</div>
        <div v-for="(text, index) in descriptionReject"
             class="bbp-project-popup-info__text"
             :key="index"
        >
          - {{text}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BBPProjectPopUpInfo',
  props: ['description', 'text', 'title', 'subTitle', 'descriptionReject', 'isDynamic']
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-project-popup-info {
    @include global-font;
    background: $color-white;
    border-radius: 4px;
    pointer-events: none;
    box-shadow: 0 0 12px rgba($color-black, 0.12);

    &_dynamic {
      white-space: pre-wrap;
    }

    &__container {
      padding: 16px;
    }

    &__header {
      padding-bottom: 12px;
      border-bottom: 1px solid $color-mercury;

      &_border {
        padding-bottom: 0;
        border-bottom: none;
      }
    }

    &__content {
      padding-top: 16px;

      &_padding {
        padding: 0;
      }
    }

    &__title {
      color: $color-denim;
      font-size: 13px;
      font-weight: 600;
      line-height: 16px;
    }

    &__text {
      color: $color-black;
      padding-top: 8px;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
    }

    &__subtitle {
      color: $color-black;
      padding-top: 8px;
      padding-bottom: 12px;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }

  .container {
    max-width: 585px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPProjectPopUpInfo/BBPProjectPopUpInfo.vue